module.exports = __webpack_public_path__ + "static/media/Timer 2.e06cd77a.png";